import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, timer, Subscription } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments';

@Injectable({
  providedIn: 'root',
})
export class UnreadChatsService implements OnDestroy {
  private readonly chatsUrl = `${environment.apiHost}/mobile/v1.0/visit-chats`;
  private readonly hasUnreadChats$ = new BehaviorSubject<boolean>(false);
  private pollingSubscription?: Subscription;

  constructor(private http: HttpClient) {}

  public getHasUnreadChats(): Observable<boolean> {
    return this.hasUnreadChats$.asObservable();
  }

  public startPolling(): void {
    if (this.pollingSubscription) {
      return;
    }

    this.pollingSubscription = timer(0, 10 * 1000)
      .pipe(
        switchMap(() =>
          this.http
            .get<{ hasUnreadChats: boolean }>(`${this.chatsUrl}/any-unread`)
            .pipe(
              map((response) => response.hasUnreadChats),
              catchError(() => of(false))
            )
        )
      )
      .subscribe((hasUnread) => {
        this.hasUnreadChats$.next(hasUnread);
      });
  }

  public stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = undefined;
    }
  }

  ngOnDestroy(): void {
    this.stopPolling();
    this.hasUnreadChats$.complete();
  }
}
